import { IPreloadedState } from 'shared/types/redux';

export const selectRegionalDistrictsStatus = (state: IPreloadedState) => state.geo.regionalDistrictsModal.status;
